module.exports = __webpack_public_path__ + "img/14.12bdf8e6.png";